import * as publicLocale from './public';
import * as privateLocale from './private';

import global from './global.json';
import errorMsg from './errorMsg.json';

const jp = { ...publicLocale, ...privateLocale, global, errorMsg };

export { jp };
